/**
 * Zákazka sa otvorí na variante, na ktorej user naposledy pracoval (KOLO 215).
 *
 * User: *„keď som naposledy pracoval na výrobnej variante zákazky, tak nech
 * mi otvoríš tú výrobnú variantu, nie výpočet"*. Do KOLA 215 sa zákazka
 * otvárala vždy na aktívnej variante (cena zákazky = výpočet, KOLO 208).
 * Pamätá si to prehliadač pre používateľa a zákazku (vzor
 * `zbalenieTabulky.ts`), aby to prežilo zatvorenie appky. Aktívnu variantu
 * pre cenu to nemení.
 */

export function klucVarianty(pouzivatel: string, zakazkaId: string): string {
  return `tandem_varianta_${pouzivatel}_${zakazkaId}`;
}

export function nacitajVariantu(kluc: string): string | null {
  try {
    return window.localStorage.getItem(kluc);
  } catch {
    return null;
  }
}

export function ulozVariantu(kluc: string, variantaId: string): void {
  try {
    window.localStorage.setItem(kluc, variantaId);
  } catch {
    // Plné alebo zablokované úložisko — zákazka sa otvorí na aktívnej
  }
}

/**
 * Záložka pri otvorení zákazky: zapamätaná, kým ešte existuje, inak
 * aktívna, inak prvá. `?varianta=` z adresy (nová časť z importu) rieši
 * editor sám a má prednosť.
 */
export function pociatocnaVarianta(
  zapamatana: string | null,
  varianty: readonly { id: string }[],
  aktivna: string | null | undefined,
): string | null {
  if (zapamatana && varianty.some((v) => v.id === zapamatana)) return zapamatana;
  return aktivna ?? varianty[0]?.id ?? null;
}

/**
 * Posledná verzia v odbore (KOLO 240) — klik na Nábytok / Tovar / Výrobu
 * v lište odborov otvorí verziu, na ktorej user v tom odbore skončil.
 */
export function klucOdboru(pouzivatel: string, zakazkaId: string, odbor: string): string {
  return `${klucVarianty(pouzivatel, zakazkaId)}_${odbor}`;
}
